import { FLOW_STEPS, STEP_ORDER } from "./constants";

// Horizontal rail of the four milestones in the HLD state machine. A step counts
// as reached once the record's status index is at or past it.
const FlowProgress = ({ status }) => {
  const currentIndex = STEP_ORDER.indexOf(status);

  return (
    <ol className="flex flex-wrap items-center gap-y-3">
      {FLOW_STEPS.map((step, index) => {
        const reached = currentIndex >= STEP_ORDER.indexOf(step.key);
        return (
          <li key={step.key} className="flex items-center">
            <span
              className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold ${
                reached ? "bg-blue-primary text-white" : "bg-gray-200 text-gray-500"
              }`}
            >
              {index + 1}
            </span>
            <span
              className={`ml-2 text-xs font-medium ${
                reached ? "text-gray-700" : "text-gray-400"
              }`}
            >
              {step.label}
            </span>
            {index < FLOW_STEPS.length - 1 && (
              <span
                className={`mx-3 h-px w-8 ${reached ? "bg-blue-primary" : "bg-gray-200"}`}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
};

export default FlowProgress;
